// extracted by mini-css-extract-plugin
export var background_available = "icon-module--background_available--vyomx";
export var big = "icon-module--big--smyeY";
export var bigger = "icon-module--bigger--Z3FyR";
export var demi = "icon-module--demi---miZg";
export var icon = "icon-module--icon--nH6gg";
export var minimal = "icon-module--minimal--cUm9R";
export var primary = "icon-module--primary--cJXUv";
export var regular = "icon-module--regular--K8Uwr";
export var secondary = "icon-module--secondary--O5KeP";
export var small = "icon-module--small--ZD0Fs";